<app-search-filter-value-list
  filterName="source"
  [keyValues]="aggregation | aggregationKeyValue: pipe.transform"
  [minResults]="1"
  (visible)="visible.next($event)"></app-search-filter-value-list>
